export default __webpack_public_path__ + "6d3f7f6c3bc566276a008c9f4f258537.png";